import { Skeleton } from '@/components/ui'

export const ConfiguracoesParametrosSkeleton = () => {
  return (
    <div className="mx-auto w-6/7 py-6">
      <Skeleton className="mb-8 h-6 w-48" />
      <div className="bg-foreground flex w-full flex-col">
        <div className="mx-6 my-8 rounded-xs border border-neutral-100 p-4 pb-0">
          <div className="space-y-6">
            <div className="flex max-w-90 flex-col gap-2">
              <Skeleton className="h-5 w-20" />
              <Skeleton className="h-11 w-full rounded-lg" />
            </div>
            <div className="flex max-w-90 flex-col gap-2">
              <Skeleton className="h-5 w-20" />
              <Skeleton className="h-11 w-full rounded-lg" />
            </div>
            <div className="flex max-w-90 flex-col gap-2">
              <Skeleton className="h-5 w-56" />
              <Skeleton className="h-11 w-full rounded-lg" />
            </div>
            <div className="flex max-w-90 flex-col gap-2">
              <Skeleton className="h-5 w-56" />
              <Skeleton className="h-11 w-full rounded-lg" />
            </div>
            <div className="mb-6 flex max-w-90 flex-col gap-2">
              <Skeleton className="h-5 w-56" />
              <Skeleton className="h-11 w-full rounded-lg" />
            </div>
          </div>
        </div>
        <div className="flex justify-end border-t border-neutral-100 px-6 py-4">
          <Skeleton className="h-10 w-20 rounded-md" />
        </div>
      </div>
    </div>
  )
}
